// extracted by mini-css-extract-plugin
module.exports = {"errorLabel":"styles_errorLabel__2GE8t","warningLabel":"styles_warningLabel__25zrw"};